const FullScreenImageGallery = {
  parts: [
    'container',
    'imageSlide',
    'image',
    'controlsContainer',
    'pausePlayButton',
    'pausePlayIcon',
    'navigationControls',
    'navButton',
    'navIcon',
    'slideCounter'
  ],
  baseStyle: {
    container: {
      position: 'relative',
      width: 'full',
      overflow: 'hidden',
      sx: {
        '.swiper': {
          width: 'full',
        },
        '.swiper-slide': {
          width: 'full',
        },
      },
    },
    imageSlide: {
      position: 'relative',
      width: 'full',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      aspectRatio: {base: '375/212', md: '1440/810'},
    },
    image: {
      width: 'full',
      height: 'full',
      objectFit: 'cover',
      position: 'absolute',
      top: 0,
      left: 0,
    },
    controlsContainer: {
      position: 'absolute',
      bottom: {base: 4, md: 8},
      left: {base: 4, md: 8},
      right: {base: 4, md: 8},
      display: 'flex',
      justifyContent: {base: 'space-between', md: 'space-between'},
      alignItems: 'center',
      pointerEvents: 'auto', // Changed from 'none' to 'auto'
      zIndex: 10,
    },
    pausePlayButton: {
      display: 'flex',
      width: {base: 8.75, md: 10},
      height: {base: 8.75, md: 10},
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0,
      backdropFilter: {base: 'blur(2px)', md: 'blur(1px)'},
      cursor: 'pointer',
      pointerEvents: 'auto',
      transition: 'all 0.2s ease',
      _hover: {
        opacity: 0.8,
      },
      _active: {
        transform: 'scale(0.95)',
      },
    },
    pausePlayIcon: {
      width: {base: 8.75, md: 10},
      height: {base: 8.75, md: 10},
      color: 'white',
      flexShrink: 0,
    },
    navigationControls: {
      display: 'flex',
      width: {base: 17, md: 27.75},
      height: {base: 7.25, md: 10},
      justifyContent: 'space-between',
      alignItems: 'center',
      flexShrink: 0,
      borderRadius: {base: '2px', md: 'base'},
      bg: 'brandColors.greyscale40',
      backdropFilter: {base: 'blur(2px)', md: 'blur(1px)'},
      position: {base: 'static', md: 'absolute'},
      left: {base: 'auto', md: '50%'},
      transform: {base: 'none', md: 'translateX(-50%)'},
      pointerEvents: 'auto',
      px: {base: 2.75, md: 3.25},
    },
    navButton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      p: {base: 0, md: 1},
      _hover: {
        opacity: 0.8,
      },
      _active: {
        transform: 'scale(0.9)',
      },
    },
    navIcon: {
      width: 2.5,
      height: 2.5,
      color: 'white',
      flexShrink: 0,
    },
    slideCounter: {
      color: 'white',
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: {base: '2xs', md: 'xs'},
      fontStyle: 'normal',
      fontWeight: 'medium',
      lineHeight: '110%',
      letterSpacing: {base: '3px', md: '3.742px'},
      position: 'relative',
    },
  },
};

export default FullScreenImageGallery;
